"use strict";
import n from "./index.es144.js";
import A from "./index.es155.js";
function p(r) {
  return n.isPlainObject(r) || n.isArray(r);
}
function B(r) {
  return n.endsWith(r, "[]") ? r.slice(0, -2) : r;
}
function w(r, i, o) {
  return r ? r.concat(i).map(function(u, a) {
    return u = B(u), !o && a ? "[" + u + "]" : u;
  }).join(o ? "." : "") : i;
}
function S(r) {
  return n.isArray(r) && !r.some(p);
}
const T = n.toFlatObject(n, {}, null, function(r) {
  return /^is[A-Z]/.test(r);
});
function U(r, i, o) {
  if (!n.isObject(r))
    throw new TypeError("target must be an object");
  i = i || new FormData(), o = n.toFlatObject(o, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(e, t) {
    return !n.isUndefined(t[e]);
  });
  const u = o.metaTokens, a = o.visitor || h, b = o.dots, m = o.indexes, y = (o.Blob || typeof Blob < "u" && Blob) && n.isSpecCompliantForm(i);
  if (!n.isFunction(a))
    throw new TypeError("visitor must be a function");
  function c(e) {
    if (e === null) return "";
    if (n.isDate(e))
      return e.toISOString();
    if (n.isBoolean(e))
      return e.toString();
    if (!y && n.isBlob(e))
      throw new A("Blob is not supported. Use a Buffer instead.");
    return n.isArrayBuffer(e) || n.isTypedArray(e) ? y && typeof Blob == "function" ? new Blob([e]) : Buffer.from(e) : e;
  }
  function h(e, t, f) {
    let s = e;
    if (e && !f && typeof e == "object") {
      if (n.endsWith(t, "{}"))
        t = u ? t : t.slice(0, -2), e = JSON.stringify(e);
      else if (n.isArray(e) && S(e) || (n.isFileList(e) || n.endsWith(t, "[]")) && (s = n.toArray(e)))
        return t = B(t), s.forEach(function(d, g) {
          !(n.isUndefined(d) || d === null) && i.append(
            // eslint-disable-next-line no-nested-ternary
            m === !0 ? w([t], g, b) : m === null ? t : t + "[]",
            c(d)
          );
        }), !1;
    }
    return p(e) ? !0 : (i.append(w(f, t, b), c(e)), !1);
  }
  const l = [], O = Object.assign(T, {
    defaultVisitor: h,
    convertValue: c,
    isVisitable: p
  });
  function j(e, t) {
    if (!n.isUndefined(e)) {
      if (l.indexOf(e) !== -1)
        throw Error("Circular reference detected in " + t.join("."));
      l.push(e), n.forEach(e, function(f, s) {
        (!(n.isUndefined(f) || f === null) && a.call(
          i,
          f,
          n.isString(s) ? s.trim() : s,
          t,
          O
        )) === !0 && j(f, t ? t.concat(s) : [s]);
      }), l.pop();
    }
  }
  if (!n.isObject(r))
    throw new TypeError("data must be an object");
  return j(r), i;
}
export {
  U as default
};
//# sourceMappingURL=index.es154.js.map
